import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './HomePage'; // Your home page
import VarleInvoiceForm from './VarleInvoice/VarleInvoice';
import VarleExcluded from './VarleExcluded';
import SpecialPrice from './SpecialPrice';

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/varlesas" element={<VarleInvoiceForm />} />
        <Route path="/exclude" element={<VarleExcluded />} />
        <Route path="/special-price" element={<SpecialPrice />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
